import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductPageContext } from "../context/ProductPageContext"

export const ProductPageAddToProject = React.memo(() => {
  const { t } = useTranslation()
  const { onAddToProject } = useProductPageContext()

  if (!onAddToProject) return null

  return (
    <Button
      variant={ButtonVariant.PRIMARY}
      data-testid="add-to-project-button"
      icon={IconName.PLUS_CIRCLE}
      onClick={onAddToProject}
      className="product-page__add-to-project"
    >
      {t("Project.AddToProjects")}
    </Button>
  )
})
